import * as React from 'react'
import { useQuery } from 'react-query'
import { IOption, IProviderProps } from '@user/components/Filters'
import { ServiceConfig } from '@user/store/services/config'
import { get } from '@user/store/services/crud'
import { ITargetPest } from '@user/store/targetPests'
import { ISearchResponse } from '@sales-center/common'

export const TargetPestsProvider: React.FC<IProviderProps> = ({ render }) => {
  const { data, isFetching } = useQuery(
    ['filters', 'opp', 'targetPests'],
    async (): Promise<IOption[]> => {
      const result = await get(
        `${ServiceConfig.baseAPIUrl}${ServiceConfig.coreProduct.targetPest}`,
      )
      const targetPests: ISearchResponse<ITargetPest> = await result.json()
      const options: IOption[] = targetPests.items.map(({ id, name }) => ({
        label: name,
        value: id,
      }))
      return options
    },
  )

  return <>{render(data ?? [], isFetching)}</>
}
TargetPestsProvider.displayName = 'TargetPestsProvider'
